// chat/index.ts
import { z } from "zod";
var ChatRequestSchema = z.object({
  messages: z.array(
    z.object({
      role: z.enum(["user", "assistant", "system", "function", "tool"]),
      content: z.string().nullable().optional(),
      name: z.string().optional(),
      function_call: z.any().optional(),
      tool_calls: z.array(z.any()).optional(),
      tool_call_id: z.string().optional(),
      toolInvocations: z.array(z.any()).optional()
    })
  ),
  model: z.string().optional(),
  tools: z.array(z.any()).optional(),
  system: z.string().optional()
});

export {
  ChatRequestSchema
};
